import React, { FC } from 'react';
import './ValidationMessage.scss';
import classNames from 'classnames';
import { ValidationMessageProps } from '../models';

const ValidationMessage: FC<ValidationMessageProps> = ({
  errorMessage,
  position = 'right',
  errorId,
}) => (
  <p
    className={classNames('validation-message', {
      'validation-message--left': position === 'left',
    })}
  >
    <span id={errorId}>{errorMessage}</span>
  </p>
);

export default ValidationMessage;
